import { Alert, Box, CircularProgress, Stack, Typography } from "@mui/material";
import type React from "react";
import { EmptyState } from "@/components/ui";
import GraphVisualization from "../components/graph-visualization.tsx";
import PageHeader from "../components/page-header.tsx";
import { useGraph } from "../hooks/use-graph.ts";

const GraphPage: React.FC = () => {
  const { data: graphInfo, isLoading: isLoadingGraph, error } = useGraph();

  if (isLoadingGraph) {
    return (
      <Box data-testid="graph-page">
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
          <CircularProgress size={16} />
          <Typography ml={2}>Loading graph...</Typography>
        </Stack>
      </Box>
    );
  }

  if (error) {
    return (
      <Box data-testid="graph-page">
        <Alert severity="error">Count not load graph: {error.message || "Unknown error"}</Alert>
      </Box>
    );
  }

  if (!graphInfo || !graphInfo.graph) {
    return (
      <Box data-testid="graph-page">
        <EmptyState variant="alert" message="No graph data available." />
      </Box>
    );
  }

  return (
    <Box data-testid="graph-page">
      <PageHeader
        title="Your Coverage"
        subtitle="Visual representation of how much of your app has been discovered, and how the different parts are connected."
      />
      <GraphVisualization
        nodes={graphInfo.graph.nodes}
        edges={graphInfo.graph.edges}
        showMinimap={true}
        enableFullscreen={true}
        responsiveHeight={true}
        layoutType="force"
      />
    </Box>
  );
};

export default GraphPage;
